import { render } from "./FileViewDialog.vue?vue&type=template&id=16db5bb3&scoped=true"
import script from "./FileViewDialog.vue?vue&type=script&lang=js"
export * from "./FileViewDialog.vue?vue&type=script&lang=js"

import "./FileViewDialog.vue?vue&type=style&index=0&id=16db5bb3&scoped=true&lang=scss"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16db5bb3"]])

export default __exports__